<rask-page pageTitle="{{ 'MOTTAGNINGSPLATS_LIST_SOK' | translate }}" noPadding>
  <ng-container header>
    @if (canCreateUtlandsk()) {
      <rask-action-button icon="fas fa-plus" (click)="createUtlandsk()">
        <rask-header noPadding>{{ 'MOTTAGNINGSPLATS_LIST_SKAPA_NY_UTLANDSK' | translate }}</rask-header>
      </rask-action-button>
    }
    @if (canCreate()) {
      <rask-action-button icon="fas fa-plus" (click)="create()">
        <rask-header noPadding>{{ 'MOTTAGNINGSPLATS_LIST_SKAPA_NY' | translate }}</rask-header>
      </rask-action-button>
    }
  </ng-container>
  <ng-container headerContent>
    <rask-search-mottagningsplats-panel (searchresult)="onResult($event)"></rask-search-mottagningsplats-panel>
  </ng-container>
  <rask-search-mottagningsplats-result  [results]="results"></rask-search-mottagningsplats-result>
</rask-page>